<template>
  <v-app>
    <v-main>
      <SocketsManager />
      <ToastrsManager />
      <ModalConfirm />
      <KC/>
      <ServerErrorView v-if="pageErrorStatus === 500"/>
      <NotFoundView v-else-if="pageErrorStatus === 404"/>
      <router-view v-else/>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import SocketsManager from '@/components/Managers/SocketsManager.vue';
import ToastrsManager from '@/components/Managers/ToastrsManager.vue';
import ModalConfirm from '@/components/Modals/ModalConfirm.vue';
import KC from '@/components/KC/KC.vue';
import NotFoundView from '@/views/NotFoundView.vue';
import ServerErrorView from '@/views/ServerErrorView.vue';
import { PageErrorStatus } from '@/store/modules/pageError';

@Options({
  components: {
    SocketsManager,
    ToastrsManager,
    ModalConfirm,
    KC,
    NotFoundView,
    ServerErrorView,
  },
})
export default class App extends Vue {
  get pageErrorStatus(): PageErrorStatus | null {
    return this.$store.getters['pageError/getStatus']
  }
}

</script>
<style lang="scss">
@import "main";
</style>